<template>
  <div class="statement-react">
    <add-button @toggleOn="addConvoStatement()" />
  </div>
</template>

<script>
  import StatementConvoAdd from "./StatementConvoAdd.ts";

  export default StatementConvoAdd;
</script>
